/**

Copyright (c) 2018, MOBICOOP. All rights reserved.
This project is dual licensed under AGPL and proprietary licence.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <gnu.org/licenses>.

Licence MOBICOOP described in the file
LICENSE
**************************/

<template>
  <div class="ion-page">
    <ion-header no-border>
      <ion-toolbar color="primary">
        <ion-buttons slot="start">
          <ion-back-button default-href="/"></ion-back-button>
        </ion-buttons>
        <h1 class="ion-text-center"> {{ $t('HitchHiking.prefs.title') }} </h1>
      </ion-toolbar>
    </ion-header>

    <ion-content color="primary">
      <div class="mc-white-container">

        <ion-label class="text-left no-white-space"><p>{{ $t('HitchHiking.register.verif-id') }}</p></ion-label>
        <div class="text-asterisk text-left" style="line-height: 12px;">
          <small v-html="$t('HitchHiking.register.verif-id-info')"></small>
        </div>
        <br>

        <ion-button class='mc-small-button' color="primary" fill="outline" expand="block" @click="$refs.docInput.click()">
          <ion-icon class="ion-margin-end" name="create"></ion-icon> {{ $t('HitchHiking.register.new-verif-id-upload') }}
        </ion-button>
        <div class="d-flex align-center justify-center color-success" v-if="identityFile">
          <ion-icon name="checkmark-circle" class="mr-3"></ion-icon> Document prêt à être expédié
        </div>
        <input ref="docInput" style="display: none" type="file" @change="changeDoc($event)" />

        <br>
        <div class="text-asterisk text-left" style="line-height: 14px;">
          <small v-html="$t('HitchHiking.register.verif-file-info')">
          </small>
        </div>
        <br>


        <ion-label style="text-align: start; margin-bottom: 5px;" class="no-white-space"><p>{{ $t('HitchHiking.register.hikeTitle') }} *</p></ion-label>
        <ion-radio-group>
          <ion-item lines="none">
            <ion-radio
              name="hitchHikeDriver"
              color="success"
              slot="start"
              @ionSelect="changeHitchHikeDriver($event)"
              :checked="user.hitchHikeDriver && !user.hitchHikePassenger"
            ></ion-radio>
            <ion-label class="no-white-space"><p>{{ $t('HitchHiking.register.driver') }}</p></ion-label>
          </ion-item>
          <ion-item lines="none">
            <ion-radio
              name="hitchHikePassenger"
              color="success"
              slot="start"
              @ionSelect="changeHitchHikePassenger($event)"
              :checked="user.hitchHikePassenger && !user.hitchHikeDriver"
            ></ion-radio>
            <ion-label class="no-white-space"><p>{{ $t('HitchHiking.register.passenger') }}</p></ion-label>
          </ion-item>
          <ion-item lines="none">
            <ion-radio
              name="hitchHikeDriverOrPassenger"
              color="success"
              slot="start"
              @ionSelect="changeHitchHikeDriverOrPassenger($event)"
              :checked="user.hitchHikePassenger && user.hitchHikeDriver"
            ></ion-radio>
            <ion-label class="no-white-space"><p>{{ $t('HitchHiking.register.driverorpassenger') }}</p></ion-label>
          </ion-item>
        </ion-radio-group>
        <!--
        <div class="text-asterisk text-left" style="line-height: 12px;">
          <small><ion-icon name="information-circle"></ion-icon> {{$t('HitchHiking.register.hikeInfo')}}</small>
        </div>
        -->
        <div v-if="$v.user.hitchHikeDriver.$error || $v.user.hitchHikePassenger.$error">
          <div class="mc-error-label">{{$t('Validation.required')}}</div>
        </div>


        <br>
        <ion-button class='mc-small-button' color="success" expand="block" @click="save()">
          <span v-if="this.$store.state.userStore.status == 'loading'">
            <ion-icon size="large" class="rotating" name="md-sync"></ion-icon>
          </span>
          <span v-if="this.$store.state.userStore.status != 'loading'">
          {{ $t('Commons.save') }}
          </span>
        </ion-button>

      </div>
    </ion-content>
  </div>
</template>

<style lang="scss">
.user-prefs-bloc-question {

  h2 {
    font-weight: 600;
    font-size: 18px;
  }

  ion-item {
    --background: #ffffff00;
    --color: var(--ion-color-primary)
  }

  background: #F5F6FA;
  border-radius: 15px;
  color: var(--ion-color-primary);
  margin-bottom: 15px;
  padding: 5px 20px;

}

.text-asterisk {
  font-size: 14px;
  color: rgba(0,0,0,0.4)
}
</style>

<script>
import {toast} from "../../Shared/Mixin/toast.mixin";
import Compressor from "compressorjs";

const checkedDriver = (value, vm) => value === true || vm.hitchHikePassenger === true;
const checkedPassenger = (value, vm) => value === true || vm.hitchHikeDriver === true;
export default {
  name: 'profile-prefs',
  data () {
    return {
      user: null
    }
  },
  mixins: [toast],
  created() {
    this.$store.state.userStore.userToUpdate = this.$store.state.userStore.user;
    this.user = this.$store.state.userStore.userToUpdate;
  },
  computed: {
    identityFile: {
      get() {
        return this.$store.state.hitchHikingStore.identityFile;
      }
    }
  },
  validations: {
    user: {
      hitchHikeDriver : {
        checkedDriver
      },
      hitchHikePassenger : {
        checkedPassenger
      }
    }
  },
  methods: {
    save() {
      this.$v.$reset();
      this.$v.$touch();
      if (this.$v.$invalid) {
        return false;
      }
      if (this.identityFile) {
        this.$store.dispatch('hitch_hicking_sendVerifId', { file: this.identityFile }).then(() => {
          this.$store.commit("hitch_hicking_reset");
          // this.user.identityStatus = 1;
          this.presentToast("Document d'identité envoyé", "success");
          this.getUser()
        }).catch(err => {
          this.$store.commit("hitch_hicking_reset");
          this.getUser()
        })
      } else {
        this.updateUser()
      }
    },
    getUser() {
      this.$store.dispatch('getUser', {idUser: this.user.id}).then(() => {
        this.$router.back();
      }).catch(() => {
        this.presentToast(this.$t("Commons.error"), "danger");
      });
    },
    updateUser() {
      this.$store.dispatch('updateUser', this.user).then(() => {
        this.$router.back();
      }).catch(() => {
        this.presentToast(this.$t("Commons.error"), "danger");
      });
    },
    changeHitchHikeDriver(event) {
      if (event.detail.checked) {
        this.user.hitchHikeDriver = true;
        this.user.hitchHikePassenger = false;
      }
    },
    changeHitchHikePassenger(event) {
      if (event.detail.checked) {
        this.user.hitchHikeDriver = false;
        this.user.hitchHikePassenger = true;
      }
    },
    changeHitchHikeDriverOrPassenger(event) {
      if (event.detail.checked) {
        this.user.hitchHikeDriver = true;
        this.user.hitchHikePassenger = true;
      }
    },
    changeDoc(e) {
      const file = e.target.files[0];
      if (file) {
        this.compressFile(file);

      }
    },
    compressFile: function (file) {
      const context = this;
      if (file.type.includes('image')) {
        new Compressor(file, {
          convertSize: 1000000,
          success(result) {
            if (result) {
              context.uploadVerifId(new File([result], file.name, {type: result.type}));
            }
          },
          error(err) {
            context.presentToast(context.$t("Commons.error"), 'danger')
          },
        });
      } else {
        context.uploadVerifId(new File([file], file.name, {type: file.type}));
      }

    },
    uploadVerifId(file) {
      this.$store.commit('hitch_hicking_update', file);
    },
  }
}
</script>
